/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * This enum represents the states the result of a step can be in.
 *
 * A single step result will probably be in multiple states during its existence.
 */
export const AutoTestStepResultState = /* #__PURE__ */ parsers.exactly('not_started', 'running', 'passed', 'failed', 'timed_out', 'skipped');
